// extracted by mini-css-extract-plugin
export default {"container":"mf2m3I"};